export default class Disciplina {
    constructor({
        descricao,
        disciplina,
        idioma,
        cargaHoraria,
        prioridade
    }) {
        this.descricao = descricao
        this.disciplina = disciplina
        this.idioma = idioma
        this.cargaHoraria = cargaHoraria
        this.prioridade = prioridade || false
    }
}